"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseMultipart = exports.getBufferedFormData = void 0;
var stream_1 = require("stream");
function getBufferedFormData(formData) {
    return new Promise(function (resolve, reject) {
        var chunks = [];
        var passThrough = formData.pipe(new stream_1.PassThrough());
        passThrough.on('data', function (chunk) { return chunks.push(chunk); });
        passThrough.on('error', reject);
        passThrough.on('end', function () {
            resolve(Buffer.concat(chunks));
        });
    });
}
exports.getBufferedFormData = getBufferedFormData;
function parseMultipart(multipart) {
    var boundary = multipart.split('\n')[0];
    var parts = multipart.split(boundary.trim()).reduce(function (accum, part) {
        var _a;
        if (!part || part.trim() === '--') {
            return accum;
        }
        var _b = part
            .split('\r\n\r\n')
            .filter(function (innerPart) { return !!innerPart; }), metadata = _b[0], value = _b[1];
        var _c = / name="(\S+)"/.exec(metadata), name = _c[1];
        return __assign(__assign({}, accum), (_a = {}, _a[name] = value.trim(), _a));
    }, {});
    return parts;
}
exports.parseMultipart = parseMultipart;
